import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import TicketList from "../views/admin/TicketList";
import TicketEditor from "../views/admin/TicketEditor";
import TicketWork from "../views/admin/TicketWork"
import roles from "../auth/roles";

const CentraleRouter = () => {

    let { path } = useRouteMatch();

    return (
        <Switch>
            <PrivateRoute
                key="dashboard"
                path={`${path}/dashboard`}
                exact
                component={() => <h3>Centrale dashboard here... work in progress!</h3>}
                roles={[roles.ADMIN, roles.CENTRALE]}
            />
            <PrivateRoute
                key="tickets"
                path={`${path}/tickets`}
                edit
                component={TicketList}
                roles={[roles.ADMIN, roles.CENTRALE]}
            />
            <PrivateRoute
                key="ticketsadd"
                path={`${path}/add-ticket`}
                edit
                component={TicketEditor}
                roles={[roles.ADMIN, roles.CENTRALE]}
            />
            <PrivateRoute
                key="ticketsadd"
                path={`${path}/work-ticket/:ticketId`}
                edit
                component={TicketWork}
                roles={[roles.ADMIN, roles.CENTRALE]}
            />
        </Switch>
    );
};

export default CentraleRouter;
